export const getVersionURL = (url) => {
    return Laya.ResourceVersion.manifest[url] || `${url}?ver=${new Date().getMinutes()}`;
};
//# sourceMappingURL=getVersionURL.js.map